'use strict';

export default function(missingDataName){
	this.message = 'Missing Data "'+missingDataName+'", using defaults.';
	this.name = 'Missing Data Exception';
}